import React, {useEffect, useState} from 'react';
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {getCustomMetricsEnabledState, setCustomMetricsEnabled} from "../../utils/FeatureFlags";
import {CustomMetricsUpgradePage} from "./CustomMetricsUpgradePage";

/**
 * Gate de la ruta `/agency/custom-metrics`.
 *
 * El flag `custom_metrics_enabled` viene del backend en `dashboard/basic-data`
 * y queda persistido en LocalStorage. Cuando el flag es `false`, mostramos el
 * paywall (CustomMetricsUpgradePage) en lugar de redirigir — el feature es
 * descubrible aunque la agencia no tenga acceso.
 *
 * El backend devuelve además `custom_metrics_public_launch` (boolean) para que
 * el FE distinga entre el período beta (true → "Próximamente", solo agency 130
 * tiene acceso real) y post-lanzamiento (false → "Disponible en Big Agency y
 * Epic Agency"). Si la key no viene, asumimos beta — más cauto.
 */
export function CustomMetricsRouteGuard({children}) {
    const initialState = getCustomMetricsEnabledState();
    const [resolved, setResolved] = useState(initialState !== null);
    const [enabled, setEnabled] = useState(initialState === true);
    const [publicLaunch, setPublicLaunch] = useState(false);

    useEffect(() => {
        if (initialState !== null) return;
        let cancelled = false;
        new APIClient(API_URL + 'dashboard/basic-data').call('GET').then((response) => {
            if (cancelled) return;
            const data = (response && response.status === 'OK' && response.data) ? response.data : {};
            const flag = data.custom_metrics_enabled === true;
            setCustomMetricsEnabled(flag);
            setEnabled(flag);
            setPublicLaunch(data.custom_metrics_public_launch === true);
            setResolved(true);
        });
        return () => { cancelled = true; };
    }, [initialState]);

    if (!resolved) {
        return (
            <div className="app-content" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh'}}>
                <span>Cargando…</span>
            </div>
        );
    }
    if (!enabled) {
        return <CustomMetricsUpgradePage mode={publicLaunch ? 'plan_locked' : 'beta'}/>;
    }
    return children;
}
